import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipDialogServiceConstants } from "../../../../constants/basics/rightship-dialog.constants";
import { computedFrom } from "aurelia-binding";
import { type IRfqMetaPlugin, QuoteLineStatusEnum } from "../../../../models/rfq/rfq.models";
import { RightStoreService } from "../../../../services/rightstore/rightstore.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { Router } from "aurelia-router";
import { GenesisRouterConstants } from "../../../../configuration/router.constants";
import { EventAggregator, Subscription } from "aurelia-event-aggregator";
import { Messages } from "../../../../configuration/event-messages.constants";

@autoinject()
@transient()
export class Rfq {

    displayFillFormLaterWhenRedirect: boolean = true;
    composeVM: any;
    viewModel: string;
    quoteGuid: string;
    currentVM: string;    
    
    private isProcessingPage: boolean;
    private _eventAggregatorSubscriptions: Subscription[] = [];

    public isRfqSubmitted: boolean;
    public disabledButtons: boolean;
    
    constructor(private i18N: I18N,
        private dialogService: DialogClientService,
        private rightStoreService: RightStoreService,
        private notificationService: NotificationClientService,
        private router: Router,
        private eventAggregator: EventAggregator) {
    }

    @computedFrom("composeVM", "composeVM.currentViewModel")
    get metaVM(): IRfqMetaPlugin {
        const vm = this.composeVM && this.composeVM.currentViewModel ? this.composeVM.currentViewModel : null;
        return vm;
    }

    async activate(args: { guid: string, vm: string }){
        if (args.vm == 'rfq-processing' && (args.guid == null || args.guid == '')) {
            this.isProcessingPage = true;
            this.viewModel = args.vm;
        } else {
            await this.fetchValidate(args);
        }
        const subscription = this.eventAggregator.subscribe(Messages.InspectedVesselChanged, (item) => {
            this.disabledButtons = item.isDisabled;
        })
        this._eventAggregatorSubscriptions.push(subscription);
    }

    deactivate(){
        this._eventAggregatorSubscriptions?.forEach(subscription => {
            subscription.dispose();
        });
        this._eventAggregatorSubscriptions = [];
    }
    async fetchValidate(args: { guid: string, vm: string }) {
        this.currentVM = args.vm;
        const quote = await this.rightStoreService.validateQuoteForInput(args.guid);
        if (!quote.isValid) {
            this.router.navigateToRoute(GenesisRouterConstants.RouteNames.StatusCode404);
        }
        if (quote.status != QuoteLineStatusEnum.Initial) {
            this.isProcessingPage = true;
            args.vm = 'rfq-processing';
        }
        this.quoteGuid = args.guid;
        this.viewModel = args.vm;
    }

    openFillFormLaterDialog(onConfirm: () => void, onCancel: () => void) {
        this.dialogService.show(RightShipDialogServiceConstants.URLs.FillFormLaterConfirmationDialog, {
            onConfirm: onConfirm,
            onCancel: onCancel,
        }, true);
    }

    async submit() {
        this.metaVM.validate();
        if (this.metaVM.canSubmit && !this.metaVM.disableSubmit && !this.isProcessingPage) {
            try {
                const submittedMeta = await this.metaVM.getMetaModel();
                const meta = JSON.stringify(submittedMeta);
                this.isRfqSubmitted = true;
                const response = await this.rightStoreService.saveRequestForQuoteMeta(this.quoteGuid.toString(), meta);
                this.notificationService.show(this.i18N.tr('successfully-saved-text'), 'Request for Quote completed', NotificationType.Success);
                if (response.quoteUrl.startsWith(location.origin)) {
                    this.router.navigate(response.quoteUrl.replace(location.origin, ""), { replace: true, trigger: true });
                }
                else {
                    location.href = response.quoteUrl;
                }
            }
            catch (e) {
                this.notificationService.show(this.i18N.tr('error-text'), 'Unable to submit the request.', NotificationType.Error);
            }
        }
    }
    
    public getViewModel(){
        if(this.viewModel) {
            require('views/pages/modules/rfq/plugins/' + this.viewModel + '/' + this.viewModel +'.ts');
            require('views/pages/modules/rfq/plugins/' + this.viewModel + '/' + this.viewModel +'.html');
            return `views/pages/modules/rfq/plugins/${this.viewModel}/${this.viewModel}`;
        }
    }
}